<template>
  <div class="product_wrapper">
    <div class="background-container">
      <div class="product-image">
        <img :src="product?.images?.icon_1200x600.src" :alt="product?.images?.icon_1200x600.alt">
        <div class="transparent-block" v-if="!mobile"></div>
        <div class="product-image__badge" v-if="product?.badge && mobile" :class="product?.badge === 2 ? 'dlc' : ''">
            <div class="product-image__badge-text">
                <svg v-if="product?.badge === 1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.0328 7.33143C12.7295 6.64871 12.2885 6.03593 11.7375 5.53143L11.2828 5.11424C11.2674 5.10046 11.2488 5.09069 11.2287 5.08577C11.2086 5.08085 11.1876 5.08094 11.1675 5.08603C11.1475 5.09112 11.129 5.10106 11.1137 5.11497C11.0984 5.12887 11.0867 5.14633 11.0797 5.1658L10.8766 5.74861C10.75 6.11424 10.5172 6.48768 10.1875 6.85487C10.1656 6.8783 10.1406 6.88455 10.1234 6.88612C10.1063 6.88768 10.0797 6.88455 10.0562 6.86268C10.0344 6.84393 10.0234 6.8158 10.025 6.78768C10.0828 5.84705 9.80156 4.78611 9.18594 3.63143C8.67656 2.67205 7.96875 1.92361 7.08437 1.40174L6.43906 1.02205C6.35469 0.972052 6.24688 1.03768 6.25156 1.13611L6.28594 1.88611C6.30937 2.39861 6.25 2.85174 6.10938 3.2283C5.9375 3.68924 5.69062 4.11736 5.375 4.50174C5.15535 4.76887 4.9064 5.01049 4.63281 5.22205C3.97391 5.72856 3.43815 6.37757 3.06562 7.12049C2.69402 7.86989 2.50045 8.69496 2.5 9.53143C2.5 10.2689 2.64531 10.983 2.93281 11.6564C3.21042 12.3048 3.61103 12.8933 4.1125 13.3892C4.61875 13.8892 5.20625 14.283 5.86094 14.5564C6.53906 14.8408 7.25781 14.9846 8 14.9846C8.74219 14.9846 9.46094 14.8408 10.1391 14.558C10.7921 14.2862 11.386 13.8897 11.8875 13.3908C12.3938 12.8908 12.7906 12.3064 13.0672 11.658C13.3543 10.9864 13.5015 10.2634 13.5 9.53299C13.5 8.77049 13.3438 8.02987 13.0328 7.33143Z" fill="#FCE9A7"/>
                </svg>
                <svg v-else-if="product?.badge === 2" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.82605 1.5H2.08675C1.76314 1.5 1.5 1.76335 1.5 2.08695V4.82605C1.5 5.14966 1.76335 5.41299 2.08695 5.41299H4.82605C5.14966 5.41299 5.41299 5.14964 5.41299 4.82605V2.08695C5.41301 1.76335 5.14966 1.5 4.82605 1.5Z" fill="#92E5FF"/>
                    <path d="M9.91197 1.5H7.17288C6.84927 1.5 6.58594 1.76335 6.58594 2.08695V4.82605C6.58594 5.14966 6.84929 5.41299 7.17288 5.41299H9.91197C10.2356 5.41299 10.4989 5.14964 10.4989 4.82605V2.08695C10.4989 1.76335 10.2356 1.5 9.91197 1.5Z" fill="#92E5FF"/>
                    <path d="M4.82605 6.58691H2.08675C1.76314 6.58691 1.5 6.85027 1.5 7.17388V9.91298C1.5 10.2366 1.76335 10.4999 2.08695 10.4999H4.82605C5.14966 10.4999 5.41299 10.2366 5.41299 9.91298V7.17388C5.41301 6.85027 5.14966 6.58691 4.82605 6.58691Z" fill="#92E5FF"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.45364 10.4991C9.5833 10.4991 10.4991 9.5833 10.4991 8.45364C10.4991 7.32398 9.5833 6.4082 8.45364 6.4082C7.32398 6.4082 6.4082 7.32398 6.4082 8.45364C6.4082 9.5833 7.32398 10.4991 8.45364 10.4991Z" fill="#92E5FF"/>
                </svg>
                <span>{{ product?.badge === 1 ? $t('Pre-order') : 'DLC' }}</span>
            </div>
            <div class="product-image__badge-date" v-if="product?.badge === 1">
                {{ getReleaseDate(product.additional_data.release_date) }}
            </div>
        </div>
      </div>
    </div>
    <div class="container container-xl">
      <!-- <Breadcrumb v-if="false" :breadcrumbs="breadcrumbs" homeUrl="/" /> -->
      <div v-if="user && !tablet && !mobile && product?.id" class="product__bookmark">
          <Bookmark :requestId="product.id" :is_bookmark="product.is_bookmark" :request="'product_id'"
              @update:bookmark="updateBookmarkStatus" />
      </div>
      <div class="product__tabs-wrap" v-if="!tablet && !mobile && tabsWithOffers && tabsWithOffers.length > 1">
          <ProductPlatformsTabs :activeTab="activePlatformTabId" :tabs="tabsWithOffers" @tab-changed="tabChangedFun"/>
      </div>
      <div class="product__head" v-if="!mobile">
          <h1 v-if="product?.name" class="product__head-title">
              {{ decodeHtmlEntities(product?.name) }}
          </h1>
          <div v-else class="product__head-title placeholder"></div>
          <!-- <p v-if="product?.description" class="product__head-description" v-html="product.description"></p>
          <p v-else class="product__head-description placeholder-wrap">
              <span class="placeholder"></span><span class="placeholder"></span>
          </p> -->
      </div>
      <div v-if="isEmptyState && mobile" class="product__empty">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.9998 1.86426C15.801 1.86426 2.6665 14.9988 2.6665 31.1976C2.6665 47.3964 15.801 60.5309 31.9998 60.5309C48.1987 60.5309 61.3332 47.3964 61.3332 31.1976C61.3332 14.9988 48.1987 1.86426 31.9998 1.86426ZM31.9998 55.5547C18.551 55.5547 7.64269 44.6464 7.64269 31.1976C7.64269 25.3702 9.6921 20.0143 13.11 15.8238L47.3736 50.0875C43.1832 53.5053 37.8272 55.5547 31.9998 55.5547ZM50.8897 46.5714L16.626 12.3077C20.8165 8.88985 26.1725 6.84045 31.9998 6.84045C45.4487 6.84045 56.357 17.7488 56.357 31.1976C56.357 37.025 54.3076 42.3809 50.8897 46.5714Z" fill="#F43232"/>
        </svg>
        <h4>{{ $t('Product out of stock', { ns: 'product' }) }}</h4>
        <p v-html="translatedEmpty"></p>
      </div>
      <ProductHeader 
        v-if="!mobile"
        :product="product?.id ? product : {}" 
        :headOffer="headOffer" 
        :mobile="mobile"
        :tablet="tablet"
        :bigDesktop="bigDesktop"
        :desktop1440="desktop1440"
        :desktop1640="desktop1640"
        :isHeadOfferLoad="isHeadOfferLoad"
        :isEmptyState="isEmptyState"
        @update:bookmark="updateBookmarkStatus"
        @update-cart="addRemoveOfferToCart"/>
      <ProductBody
        v-if="activeTab?.active_offers_count && (mobile ? activeTab.active_offers_count > 0 : activeTab.active_offers_count > 1)"
        ref="ProductBodyRef"
        :isOnlineGame="product?.is_online_game"
        :mobile="mobile"
        :tablet="tablet"
        :tabletMax="tabletMax"
        :filters="filters"
        :bigDesktop="bigDesktop"
        :offersMeta="offersMeta"
        :tabsArray="tabsWithOffers"
        :productOffers="productOffers"
        :product="product?.id ? product : {}" 
        :productOffersRecomended="productOffersRecomended"
        :isProductOffersLoad="isProductOffersLoad"
        :isOffersFiltersLoad="isOffersFiltersLoad"
        :isUpdatePaginations="isUpdatePaginations"
        @update-page="fetchOffersPage"
        @update-filters="fetchOffersFilters"
        @update:bookmark="updateBookmarkStatus"
        @update:platform-tab-id="tabChangedFun"
        @update-cart="addRemoveOfferToCart"/>
      <AboutProduct 
        :product="product?.id ? product : {}" 
        :activeTabObj="activeTab" 
        :tablet="tablet" 
        :tabletMax="tabletMax"
        :mobile="mobile"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Bookmark from './parts/Bookmark.vue';
import Breadcrumb from '../../../components/Breadcrumbs.vue';
import ProductPlatformsTabs from './parts/ProductPlatformsTabs.vue';
import ProductHeader from './parts/ProductHeader.vue';
import ProductBody from './parts/ProductBody.vue';
import AboutProduct from './parts/AboutProduct.vue';
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
  components: {
    Bookmark,
    Breadcrumb,
    ProductPlatformsTabs,
    ProductHeader,
    ProductBody,
    AboutProduct
  },
  data() {
    return {
      product: window.settings.product || null,
      user: window.common.user || null,
      activePlatformTabId: window.settings.product.id,
      tabsArray: window.settings.tabs,
      activeTab: null,
      settings: window.settings,
      mobile: false,
      tablet: false,
      tabletMax: false,
      bigDesktop: false,
      desktop1440: false,
      desktop1640: false,
      offersMeta: null,
      allOffers: [],
      filters: {},
      productOffers: [{id: null}],
      productOffersRecomended: [],
      headOffer: {id: null},
      isHeadOfferLoad: false,
      isProductOffersLoad: false,
      isOffersFiltersLoad: false,
      isEmptyState: false,
      paramsFetch: null,
      isUpdatePaginations: false,
      tabsWithOffers: null
    };
  },
  mounted() {
    const width = window.innerWidth;
    this.mobile = width <= 767;
    this.tablet = width > 767 && width < 992;
    this.tabletMax = width < 1024;
    this.desktop1440 = width < 1440;
    this.desktop1640 = width < 1640;
    this.bigDesktop = width > 1919;

    const params = new URLSearchParams(window.location.search);

    this.paramsFetch = Object.fromEntries(params.entries());

    this.activeTabFun(this.activePlatformTabId);
    this.fetchProduct('platform');

    setTimeout(()=>{
        window.tagTracking("viewOffers", this.dataInfo)
    },2000)
  },
  created() {
    window.addEventListener('updateIsAddedToCart', this.handleUpdateIsAddedToCart);
    window.addEventListener('updateVueBookmark', this.handleUpdateVueBookmark);
  },
  destroyed() {
    window.removeEventListener('updateIsAddedToCart', this.handleUpdateIsAddedToCart);
    window.addEventListener('updateVueBookmark', this.handleUpdateVueBookmark);
  },
  methods: {
    decodeHtmlEntities,
    activeTabFun(id){
      this.tabsWithOffers = this.tabsArray.filter(tab => Number(tab.active_offers_count) > 0);
      if(!this.tabsArray.length) {
        this.isEmptyState = true;
        return
      }

      this.activeTab = this.tabsArray.find(
        tab => tab.product_id === id
      );

      if(this.activeTab?.active_offers_count && this.activeTab.active_offers_count === 0) {
        this.isEmptyState = true;
      } else {
        this.isEmptyState = false;
      }
      if (this.activeTab && this.activeTab.url) {
          const currentUrl = window.location.pathname + window.location.search;
          if (currentUrl !== this.activeTab.url) {
              window.history.pushState({}, '', this.activeTab.url);
              //this.updateUrl();
          }
      }
    },
    updateBookmarkStatus({ id, newStatus }) {
      if(id === this.product.id) {
        this.product.is_bookmark = newStatus
      } else {
        const allOffers = [...this.productOffers, ...this.productOffersRecomended];

        allOffers.forEach(offer => {
          if (offer.id === id) {
            offer.is_bookmark = newStatus;
          }
        });
        if(this.headOffer.id === id) {
          this.headOffer.is_bookmark = newStatus;
        }
      }
    },
    tabChangedFun(id) {
      const tab = this.tabsArray.find(t => t.product_id === id);
      if (!tab) return;
      this.activeTab = tab

      if (this.activePlatformTabId === id) return;
      this.activePlatformTabId = id;
      this.activeTabFun(id);
      this.fetchProduct('change-tab', tab.api_url);
    },
    async fetchOffersFilters(paramProp) {
      if(!this.tabsArray.length) {
        return
      }
      const baseUrl = `${this.activeTab.api_url}/offers`;
      this.isProductOffersLoad = false;
      this.isUpdatePaginations = false;
      const params = {
          ...paramProp,
          per_page: 10,
          page: 1
      };
      this.paramsFetch = this.updateParams(params)
      this.updateUrl();
      const [offersRes, filtersRes] = await Promise.all([
        axios.get(`${baseUrl}`, { params: this.paramsFetch }),
        axios.get(`${baseUrl}/meta`, { params: this.paramsFetch })
      ]);
      this.allOffers = offersRes.data.data;
      this.offersMeta = offersRes.data.meta;
      this.filters = filtersRes.data;
      this.headOffer = offersRes.data?.data?.[0] ?? null;
      this.isProductOffersLoad = true;
      this.isUpdatePaginations = true;
      this.filterRecomendedOffers(this.allOffers)
    },
    async fetchOffersPage({page, showMore}) {
      if(!this.tabsArray.length) {
        return
      }
      const baseUrl = `${this.activeTab.api_url}/offers`;
      const params = {
        page: page || 1,
        per_page: 10
      };
      this.paramsFetch = this.updateParams(params)
      this.updateUrl();
      if (!showMore) {
          this.isProductOffersLoad = false; 
      }
      
      try {
        const response = await axios.get(baseUrl, { params: this.paramsFetch });
        if (showMore) {
          this.allOffers = [...this.allOffers, ...response.data.data];
        } else {
          this.allOffers = response.data.data;
        }
        this.filterRecomendedOffers(this.allOffers)
        this.offersMeta = response.data.meta;
        this.isProductOffersLoad = true; 
      } catch (error) {
        console.error('Error fetching offers:', error);
      }
    },
    async fetchProduct(param, product_url = null) {
      if(!this.tabsArray.length) {
        return
      }
      try {
        this.isProductOffersLoad = false;
        this.isHeadOfferLoad = false;
        this.isOffersFiltersLoad = false;
        const isTabChange = param === 'change-tab';

        const baseUrl = isTabChange && product_url
          ? product_url
          : this.activeTab.api_url;

        const offersCount = 10;

        let productRes = null;
        let offersRes = null;
        let filtersRes = null;
        let params = { 
          per_page: offersCount,
          order_by_region: 1,
          order_by_price: 1
        }
        this.paramsFetch = this.updateParams(params)
        this.updateUrl();
        
        if (isTabChange) {
          productRes = await axios.get(baseUrl);
          this.product = productRes.data;
          this.isUpdatePaginations = false;
          this.paramsFetch = { 
            per_page: offersCount,
            order_by_region: 1,
            order_by_price: 1
          }
          this.updateUrl();
        }
        if (this.mobile) {
          [offersRes, filtersRes] = await Promise.all([
            axios.get(`${baseUrl}/offers`, { params: this.paramsFetch }),
            axios.get(`${baseUrl}/offers/meta`, { params: this.paramsFetch })
          ]);
        } else {
          [offersRes, filtersRes] = await Promise.all([
            axios.get(`${baseUrl}/offers`, { params: this.paramsFetch }),
            axios.get(`${baseUrl}/offers/meta`, { params: this.paramsFetch })
          ]);
        }

        this.filters = filtersRes.data;
        this.allOffers = offersRes.data.data;
        this.offersMeta = offersRes.data.meta;

        this.filterRecomendedOffers(this.allOffers);
 
        this.headOffer = offersRes?.data?.data?.[0] ?? null;
        this.isProductOffersLoad = true;
        this.isHeadOfferLoad = true;
        this.isOffersFiltersLoad = true;
        this.isUpdatePaginations = true;
      } catch (error) {
        console.error("Error:", error);
      }
    },
    updateParams(updates) {
      const obj = { ...this.paramsFetch };
      
      Object.entries(updates).forEach(([key, value]) => {
        obj[key] = value;
      });
      return obj;
    },
    updateUrl() {
      const queryString = new URLSearchParams(this.paramsFetch).toString();
      const newUrl = `${window.location.pathname}?${queryString}`;
      window.history.replaceState(null, "", newUrl);
    },
    filterRecomendedOffers(offers) {
      this.productOffersRecomended = offers.filter(offer => offer.is_recommended === true);

      this.productOffers = offers.filter(offer => offer.is_recommended === false);
    },
    handleCartOffers(id, isAdd) {
      const allOffers = [...this.productOffers, ...this.productOffersRecomended];
      allOffers.forEach(offer => {
        if (offer.id === id) {
          offer.is_added_to_cart = isAdd;
        }
      });
      if(this.headOffer.id === id) {
        this.headOffer.is_added_to_cart = isAdd;
      }
    },
    handleUpdateIsAddedToCart(){
      const {itemId} = event.detail;
      this.handleCartOffers(itemId, false)
    },
    handleUpdateVueBookmark(){
      const {itemId} = event.detail;
      if(+itemId === this.product.id) {
        this.product.is_bookmark = !this.product.is_bookmark
      } else {
        const allOffers = [...this.productOffers, ...this.productOffersRecomended];

        allOffers.forEach(offer => {
          if (offer.id === +itemId) {
            offer.is_bookmark = !offer.is_bookmark;
          }
        });
        if(this.headOffer.id === +itemId) {
          this.headOffer.is_bookmark = !this.headOffer.is_bookmark;
        }
      }
    },
    addRemoveOfferToCart({ offerId, isAdd, amount }) {
      if (isAdd) {
        const allOffers = [...this.productOffers, ...this.productOffersRecomended];
        const offerCoupon = allOffers.find(offer => offer.id === offerId)?.coupon?.code;
        const params = new URLSearchParams(window.location.search);
        const couponParam = offerCoupon ?? params.get('coupon');
        let data = { amount: amount };
        data.coupon = couponParam;

        $.ajax({
          type: "POST",
          url: `/cart/add/${offerId}`,
          data: data,
          success: () => {
            //window.tagTracking("addToCart", dataInfo);
            this.handleCartOffers(offerId, true);
            if (typeof window.updateMiniCarts === "function") {
              window.updateMiniCarts(1, offerId, true, couponParam);
            }
          },
          error: function (xhr, status, error) {
            console.error(error);
            window.location.href = "/signup";
          }
        });
      } else {
        window.updateMiniCarts(0, offerId);
        this.handleCartOffers(offerId, false)
        //window.tagTracking("removeFromCart", dataInfo)
      }
    },
    getReleaseDate(dateStr) {
        if (!dateStr) return '';

        const locale = this.language || 'en';

        const date = new Date(dateStr);
        if (isNaN(date)) return '';

        const day = String(date.getUTCDate()).padStart(2, '0');
        const monthName = new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(date);
        const year = date.getUTCFullYear();

        return `${day} ${monthName} ${year}`;
    },
  },
  computed: {
    translatedEmpty() {
      return this.$t('Unfortunately, at the moment there are no product offers, you can choose another product in our {link}', {
        link: '<a href="/product" target="_blank" rel="nofollow noopener" class="link">' + this.$t('Catalogue') + '</a>',
        ns: 'product'
      });
    },
  }
};
</script>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}
.product_wrapper{
  background-color: #f5f5f5;
}
.container{
  position: relative;
  z-index: 2;
}
.background-container {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  pointer-events: none;
  max-height: 612px;
  overflow: hidden;
  @media only screen and (min-width: 2300px) {
    max-height: none;
  }
  @media only screen and (max-width: 1919px) {
    max-height: 523px;
  }
  @media only screen and (max-width: 1279px) {
    max-height: 460px;
  }
  @media only screen and (max-width: 767px) {
    position: relative;
    padding-top: 0;
    max-height: 210px;
    height: 210px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .product-image {
    width: calc(100% + 40px);
    height: 100%;
    margin: 0 -20px;
    background-size: 100%;
    background-position: center bottom;
    background-repeat: no-repeat;
    filter: blur(10px);
    mask-image: url('/webpack-assets/img/product/mask.svg');
    mask-repeat: no-repeat;
    mask-size: 100%;
    mask-position: 0 bottom;
    //position: relative;
    z-index: 1;
    pointer-events: none;
    display: flex;
    @media only screen and (min-width: 1920px) {
      mask-position: 0 bottom;
    }

    @media only screen and (min-width: 2300px) {
      mask-position: 0 -100px;
    }

    @media only screen and (min-width: 2560px) {
      mask-position: 0 -300px;
    }

    @media only screen and (min-width: 2760px) {
      mask-position: 0 -500px;
    }

    @media only screen and (max-width: 1640px) {
      mask-position: 0 bottom;
    }

    @media only screen and (max-width: 1200px) {
      mask-position: 0 0;
    }
    @media only screen and (max-width: 767px) {
      filter: none;
      mask-image: none;
      height: auto;
    }
    img {
      width: 100%;
      position: absolute;
      left: 0;
      top: 50%;
      z-index: 1;
      transform: translateY(-45%);
      @media only screen and (max-width: 767px) {
        position: relative;
        transform: translate(0, 0);
        top: 0;
      }
    }
    &__badge{
        z-index: 10;
        position: absolute;
        backdrop-filter: blur(8px);
        background: rgba(157, 123, 0, .4);
        border-radius: 8px;
        top: 10px;
        left: 10px;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        &-text{
            display: flex;
            align-items: center;
            gap: 6px;
            span{
                color: #FCE9A7;
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 400;
                font-size: 12px;
                line-height: 140%;
            }
        }
        &-date{
            color: #FCE9A7;
            font-family: "Avenir-Next", sans-serif;
            font-weight: 400;
            font-size: 12px;
            line-height: 140%;
            margin-left: 10px;
            padding-left: 10px;
            border-left: 1px solid #FCE9A7;
        }
        &.dlc{
          background: #44F1FC80;
          .product-image__badge-tex{
              span{
                  color: #92E5FF;
              }
          }
      }
    }
    .transparent-block {
      background-color: #11151A80;
      height: 100%;
      position: absolute;
      top: 0;
      width: 100%;
      //filter: blur(10px);
      z-index: 10;
    }
  }
}
.product{
  &__tabs-wrap{
    padding-top: 30px;
    display: flex;
    justify-content: center;
  }
  &__bookmark{
    position: absolute;
    right: 0;
    top: 0;
    width: 90px;
    height: 106px;
    display: flex;
    justify-content: center;
    padding-top: 14px;
    background-image: url('/webpack-assets/img/product/bookmark-bg.svg');
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  &__empty{
    background-color: #fff;
    display: flex;
    padding: 15px;
    margin: 0 -15px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    svg{
        margin-bottom: 30px;
    }
    h4{
        font-family: "Avenir-Next-DemiBold", sans-serif;
        font-weight: 400;
        font-size: 22px;
        color: #1F1F1F;
        line-height: 140%;
        padding-bottom: 10px;
        text-align: center;
    }
    p{
        font-family: "Avenir-Next";
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        line-height: 24px;
        letter-spacing: 0px;
        color: #9D9D9D;
        :deep(a){
            color: #4E8AFF;
        }
    }
  }
  &__head{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding: 30px 0 50px;
    @media only screen and (max-width: 1919px) {
      padding: 30px 0 35px;
    }
    @media only screen and (max-width: 1639px) {
      padding: 30px 0 35px;
    }
    @media only screen and (max-width: 1023px) {
      padding: 30px 0 30px;
    }
    &-title{
      font-family: "Avenir-Next-DemiBold", sans-serif;
      font-weight: 400;
      font-size: 40px;
      line-height: 140%;
      letter-spacing: 0px;
      text-transform: uppercase;
      text-align: center;
      color: #f6f6f6;
      @media only screen and (max-width: 1023px) {
        font-size: 28px;
        line-height: 120%;
      }
      &.placeholder{
        width: 660px;
        height: 56px;
        border-radius: 11px;
      }
    }
    &-description{
      font-family: "Avenir-Next", sans-serif;
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: center;
      color: #f6f6f6;
      max-width: 792px;
      height: 50px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: 0.5px;
      @media only screen and (max-width: 1919px) {
        font-size: 16px;
      }
      :deep(h1),
      :deep(h2),
      :deep(h3),
      :deep(a),
      :deep(p),
      :deep(span) { 
          text-align: center !important;
      }
      &.placeholder-wrap{
        height: 56px;
        width: 100%;
        span{
          display: block;
          width: 100%;
          height: 24px;
          border-radius: 11px;
          &:last-child{
            width: 50%;
            margin: 8px auto 0;
          }
        }
      }
    }
  }
}
</style>
